
<template>
  <div class="ipDashboard">
    <vx-card style="min-height: 540px">
      <vue-good-table
        mode="remote"
        :pagination-options="{
          enabled: true,
        }"
        :sort-options="{
          enabled: false,
        }"
        :totalRows="totalRecords"
        :rows="rows"
        :columns="columns"
        :isLoading.sync="isLoading"
        @on-column-filter="onColumnFilter"
        @on-page-change="onPageChange"
        @on-row-dblclick="navigate"
        styleClass="vgt-table condensed"
      />
    </vx-card>
  </div>
</template>
<script>
import flatPickr from "flatpickr";
// import flatPickr from 'vue-flatpickr-component';
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      components: {
        flatPickr,
      },
      isLoading: false,
      columns: [
        {
          label: "IP NO",
          field: "ipNo",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          thClass: "text-left pl-4",
          tdClass: "text-left pl-4",

          width: "100px",
        },
        {
          label: "IP DATE",
          field: "ipDate",
          type: "date",
          dateInputFormat: "dd/mm/yyyy",
          dateOutputFormat: "dd/mm/yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "dd/mm/yy", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "130px",
        },
        {
          label: "PATIENT NAME",
          field: "patientName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "180px",
        },
        {
          label: "AGE",
          field: "patientAge",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "100px",
        },
      

        {
          label: "PHONE NO",
          field: "patientPhoneNo",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "130px",
        },
        {
          label: "DOCTOR NAME",
          field: "doctorName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "170px",
        },
        {
          label: "ROOM NO",
          field: "roomNo",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
         

          width: "100px",
        },
             {
          label: "STATUS",
          field: "dischargeStatus",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "120px",
        },
        {
          label: "DIS.DATE",
          field: "dischargeDate",
          type: "date",
          dateInputFormat: "yyyy-mm-dd",
          dateOutputFormat: "dd/mm/yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "dd/mm/yy", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          width: "130px",
        },
     
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        companyId: this.$session.get('companyId'),
        filter: {},
        currentPage: 1,
        limit: 10,
      },
    };
  },

   mounted() {
    let inputs = ['input[placeholder="dd/mm/yy"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        // dateFormat: "m-d-Y",
        dateFormat: "d-m-Y",
        // mode: "range",
        allowInput: true,
      });
    });
    
    const savedFilters = this.$store.state.ipDashboardFilters;

    if (savedFilters) {
      this.serverParams = savedFilters;

      const updatedColumns = this.columns.map((col) => {
        if (savedFilters.filter && savedFilters.filter[col.field]) {
          return {
            ...col,
            filterOptions: {
              ...(col.filterOptions || {}),
              filterValue: savedFilters.filter[col.field],
            },
          };
        }
        return col;
      });
      this.columns = updatedColumns;

      this.$store.commit("updateipDashboardFilters", null);
    }
    this.loadItems();
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      console.log(params);
      this.updateParams({
        currentPage: params.currentPage,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams({
        filter: params.columnFilters,
      });
      this.loadItems();
    },
    loadItems() {
       this.isLoading = true;
      this.$http
        .post("/ipDashboardDetails", JSON.stringify(this.serverParams), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response from patient back end", response.data.data);
          this.totalRecords = response.data.recordsTotal;
          this.rows = response.data.data;
        })
        .catch((error) => {
      console.error("Error loading patient data:", error);
      this.$vs.notify({
        title: "Error",
        text: "Failed to load patient list.",
        color: "danger",
        position: "top-center",
      });
    })
    .finally(() => {
      this.isLoading = false;
    });
        
    },
    
    navigate(item, index, event) {
      this.$store.commit("updateipDashboardFilters", this.serverParams);
      console.log(item, index, event);
      console.log(item.row.opNo);
      var selectedPatientId = item.row.patientId;
        var selectedipNo=item.row.ipNo
    
          this.$router.push({
                path: 'ipDetails',
                query: {
                    patientId: selectedPatientId,
                    IpId: selectedipNo
                }
            })
      
    },
  }
}

</script>

<!--<template>
    <div class="ipDashboard">
        <vx-card>
            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 h-50 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="rowData" :floatingFilter="true" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :frameworkComponents="frameworkComponents">
            </ag-grid-vue>
            <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
    </div>
</template>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import flatPickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";


export default {
    components: {
        AgGridVue,flatPickr
    },  
    data(){
        return{
            frameworkComponents: {
                agDateInput: Datepicker
            },
            gridOptions: {
                enableBrowserTooltips: true,
                onFilterChanged: this.onGridReady,
                rowModelType: 'infinite',
                onRowDoubleClicked: this.navigate,
                rowSelection: "single",
                floatingFiltersHeight: 40,
                rowStyle: {
                    'text-align': 'center',
                    'cursor': 'pointer'
                }
            },
            maxPageNumbers: 5,
            gridApi: null,
            defaultColDef: {

                sortable: false,
                resizable: true,
                filter: true,
                suppressMenu: true,

                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },
                filterParams: {
                    newRowsAction: 'keep',

                }

            },
            columnDefs: [{
                    headerName: 'IpNumber',
                    field: 'ipNo',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width: 99,
                    tooltipValueGetter: (params) => {
                        return 'Double click to view IP'
                    }
                },
                {
                    headerName: 'IpDate',
                    field: 'ipDate',
                    filter: 'agDateColumnFilter',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filterParams: {
                        newRowsAction: 'keep',
                        // browserDatePicker: true
                    },
                    width: 186,
                    tooltipValueGetter: (params) => {
                        return 'Double click to view IP'
                    }
                },
                {
                    headerName: 'Patient Name',
                    field: 'patientName',
                    cellStyle: {
                        'text-align': 'left'
                    },
                    filter: true,
                    width: 190,
                    tooltipValueGetter: (params) => {
                        return 'Double click to view IP'
                    }
                },
                {
                    headerName: 'Patient PhoneNo',
                    field: 'patientPhoneNo',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width: 229,
                    tooltipValueGetter: (params) => {
                        return 'Double click to view IP'
                    }
                },
                {
                    headerName: 'Doctor Name',
                    field: 'doctorName',
                    filter: true,
                    width: 298,
                    cellStyle: {
                        'text-align': 'left'
                    },
                    tooltipValueGetter: (params) => {
                        return 'Double click to view IP'
                    }
                }   
            ],
            rowData: null,
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 8
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady();
            }
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit();
            this.$nextTick(() => {
      setTimeout(() => {
        const dateInputs = document.querySelectorAll('.ag-floating-filter-input input');
        dateInputs.forEach((input) => {
          if (input.placeholder === '' || input.placeholder.includes('Date')) {
            input.placeholder = 'dd/mm/yy'; // same placeholder as patient dashboard
            flatPickr(input, {
              dateFormat: "d-m-Y",
              allowInput: true,
            });
          }
        });
      }, 600);
    });
  },
    
    methods:{
        onGridReady(params) {
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            console.log(JSON.stringify(request));
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                        "/ipDashboardDetails",
                        JSON.stringify(request), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(response => {
                        params.successCallback(response.data.data, response.data.recordsTotal);
                        this.gridApi.hideOverlay();
                    });
                }
            }
            this.gridApi.setDatasource(datasource);
        },
        navigate() {
            var selectedrow = this.gridApi.getSelectedRows();
            var selectedipNo = "";
            var selectedPatientId = "";
        
            selectedrow.forEach((value) => {
                selectedipNo=value.ipNo;
                selectedPatientId=value.patientId;
            })
            console.log(selectedPatientId);
             this.$router.push({
                path: 'ipDetails',
                query: {
                    patientId: selectedPatientId,
                    IpId: selectedipNo
                }
            })
        }
    }
}
</script>-->
<style >
.vgt-table thead th {
  background: white;
}
.vgt-wrap__footer {
  background: white;
}
table.vgt-table {
  font-size: 12px;
  border: none;
}
.vgt-right-align {
  text-align: left;
}
.vgt-table.condensed tr {
  height: 56px;
}
.vgt-table.condensed td {
  padding-top: 19px;
}
.vgt-input {
  border: none;
}
.vgt-wrap__footer {
  border: none;
}

.flatpickr-rContainer {
  width: 95% !important;
}
.dayContainer {
  min-width: 86% !important;
  max-width: 86% !important;
}

.flatpickr-monthDropdown-months {
  margin-left: -18%;
}
.flatpickr-monthDropdown-month {
  font-size: 11 !important;
}
.flatpickr-next-month {
  right: 57px !important;
}
.flatpickr-months {
  width: 97%;
}
.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}
.patientDashboard .vgt-table thead th:nth-child(4) input {
  
  text-align: center !important;
}

</style>
